module.exports = __webpack_public_path__ + "static/media/tending-hives.3095fc20.png";